"use strict";
export var WrapType = /* @__PURE__ */ ((WrapType2) => {
  WrapType2[WrapType2["NotApplicable"] = 0] = "NotApplicable";
  WrapType2[WrapType2["Wrap"] = 1] = "Wrap";
  WrapType2[WrapType2["Unwrap"] = 2] = "Unwrap";
  return WrapType2;
})(WrapType || {});
